import Errors from "./Errors";

export default function validateBillingAddress(firstName, lastName, street1, city, postalcode, region, countryCode) {
  let errors = new Errors();
  errors = errors.clearAll();
  if (!firstName) {
    errors = errors.addError('firstName', 'error.billing-first-name-required');
  }
  if (!lastName) {
    errors = errors.addError('lastName', 'error.billing-last-name-required');
  }
  if (!street1) {
    errors = errors.addError('addressLine1', 'error.billing-street1-required');
  }
  if (!city) {
    errors = errors.addError('city', 'error.billing-city-required');
  }
  if (!postalcode) {
    errors = errors.addError('postalCode', 'error.billing-postalcode-required');
  }
  if (!region) {
    errors = errors.addError('region', 'error.billing-region-required');
  }
  if (!countryCode) {
    errors = errors.addError('country', 'error.billing-country-required');
  }
  return errors;
}
